import { takeLatest, put } from 'redux-saga/effects';
import { StatusUpdatesAPI } from 'api/status-updates';
import { getStatusUpdates } from '../actions';
import { setStatusUpdates, setStatusUpdatesLoading } from '../slice';
function* getStatusUpdatesManager(action) {
    const { payload } = action;
    try {
        yield put(setStatusUpdates([]));
        yield put(setStatusUpdatesLoading(true));
        const response = yield StatusUpdatesAPI.getStatusUpdatesList(payload.projectId);
        yield put(setStatusUpdates(response));
    } catch (unused) {
    // TODO
    }
}
export const watchGetStatusUpdates = function*() {
    yield takeLatest(getStatusUpdates.type, getStatusUpdatesManager);
};
